<div class="col-lg-3 pr-0 float-left mb-3 p-res-0 product-res-grid" (click)="goToDetail($event)">
  <div class="col-lg-12 border-top border-left border-right border-bottom product-card p-2 float-left cursor-pointer" [ngClass]="{'block-height': (product?.hasPricing), 'block-height-short': (!product?.hasPricing)}">
    <div class="product-card-content d-flex flex-column h-100">
      <div class="product-image mb-4 mt-2">
        <cx-media [container]="product?.images?.PRIMARY" [format]="'thumbnail'" [alt]="product?.summary"></cx-media>
      </div>

      <div class="brand-logo mb-3 d-flex justify-content-center">
        <div [innerHTML]="getSVGImage(salesOrg.imgUrl)" class="brand-img"></div>
      </div>

      <div class="product-info p-0">
        <div class="product-title mb-1">
          <span class="color-font font-size font-weight700">{{ product?.name }}</span>
        </div>
        @if (getAddToCart(product)) {
        <div class="product-code">
          <span class="color-font">Material #: {{ product?.defaultVariantProduct }}</span>
        </div>
      }
        @if (product?.hasPricing && product?.rfqEligible == "Yes") {
          <div class="product-price">
            <span class="color-font">
              {{ 'productList.label.listPrice' | cxTranslate }}:
              {{ product?.price?.value === 0 ? 'Request a Quote' : product?.price?.formattedValue }}
            </span>
          </div>
          <div class="product-price">
            <span class="color-font">
              {{ 'productList.label.netPrice' | cxTranslate }}:
              {{ product?.price?.netPrice  === 0 ? 'Request a Quote' : product?.price?.formatedNetPrice }}
            </span>
          </div>
         }
      </div>
      @if (getAddToCart(product)) {
      <div class="product-actions d-flex flex-column align-items-center justify-content-end">
        <div class="quantity-section mb-3">
          @if(product?.rfqEligible == "Yes") {
            <span class="quantity-label">Qty:</span>
          } @else {
            <span class="quantity-label">Qty @if( product?.maxOrderQuantity && product?.maxOrderQuantity!=='' && product?.maxOrderQuantity!==null){<span class="max-qty">(Max {{ product?.maxOrderQuantity }})</span>}:</span>
          }
          <div class="quantity-controls">
            <button type="button" class="quantity-btn" aria-label="Decrease quantity"
              (click)="decrementQuantity()">&minus;</button>
            <input type="number" class="quantity-input" [value]="quantity" (blur)="onQuantityChange($event)" min="1"
              knBrNumbersOnly>
            <button type="button" class="quantity-btn" aria-label="Increase quantity"
              (click)="incrementQuantity()">+</button>
          </div>
        </div>

        <div class="add-to-cart-wrapper w-100 d-flex justify-content-center">
          <kn-br-add-to-cart [plpQuantity]="quantity" [type]="'PLP'" [product]="product"></kn-br-add-to-cart>
        </div>
      </div>
      }
    </div>
  </div>
</div>
